import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { HelmetProvider } from "react-helmet-async";

import { locationDetailsOperations } from "../ducks/location-details";
import Details from "../components/details/Details";
import Error from "../components/misc/Error";
import Loading from "../components/misc/Loading";

class ZipContainer extends React.Component {
    componentDidMount() {
        this.props.fetchLocationByZip();
    }

    render() {
        if (this.props.error) {
            return <Error error={this.props.error} />;
        }

        if (this.props.loading) {
            return <Loading />;
        }

        return (
            <HelmetProvider>
                <Details location={this.props.location} />
            </HelmetProvider>
        );
    }
}

const propTypes = {
    locations: PropTypes.object,
    loading: PropTypes.bool
};

ZipContainer.propTypes = propTypes;

const mapStateToProps = state => ({
    error: state.locationDetails.error,
    loading: state.locationDetails.loading,
    location: state.locationDetails.details
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    fetchLocationByZip: () =>
        locationDetailsOperations.fetchLocationByZip(ownProps.$stateParams.zip)(
            dispatch
        )
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ZipContainer);



// WEBPACK FOOTER //
// ./containers/ZipContainer.jsx